module.exports = __webpack_public_path__ + "img/easy2roll.07d31378.png";